export function clearPhone( phone ){
    return phone.replace( /[^0-9]/gi , '' ).trim();
}

export function clearName( name ){
    return name.replace( /[^а-яёА-ЯЁa-zA-z\s]/gi , '' ).replace( /\s+/gi , ' ' ).trim();
}

export function clearEmail( email ){
    return email.toLowerCase().replace( /[\s!#$%&~=,'"]/gi , '' ).replace( /\.+/gi , '.' ).trim();
}

export function hrefPhone( phone ){
    let temp = clearPhone( phone );
    return ( temp.substring( 0 , 1 ) === '8' ? '' : '+' ) + temp;
}

export function prettyMoney( money ){
    return money ? money.toLocaleString( 'ru-RU' , { useGrouping : true } ) : 0;
}

export function prettyPhone( phone ){
    let matches = clearPhone( phone ).match( /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/i )
    return `+${ matches[ 1 ] ?? '' } ( ${ matches[ 2 ] ?? '' } ) ${ matches[ 3 ] ?? '' }-${ matches[ 4 ] ?? '' }-${ matches[ 5 ] ?? '' }`;
}

